import axios, { AxiosError } from "axios";

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { SearchProfileRequestData } from "@/types";
import { GET_SEARCH_PROFILE } from "@/constants";

export const useCreateSearchProfile = (onSuccess: () => void) =>
  useMutation<unknown, AxiosError, SearchProfileRequestData>({
    onSuccess: onSuccess,
    mutationFn: ({ profileObj }) =>
      axios
        .post(`${GET_SEARCH_PROFILE}`, profileObj)
        .then((res) => {
          return res.data;
        }),
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
